import { DigitalProductInterface } from 'modules/digital-product/types/digital-product-interface'
import { ReactNode } from 'react'
import { FormSelectDataType } from 'shared/components'

export const getDigitalProductsData = (
  digitalProductList: DigitalProductInterface[],
  isBump?: boolean,
  getAdditionalRender?: (id: number) => ReactNode,
): FormSelectDataType<number>[] =>
  digitalProductList
    ?.filter(digitalProduct => (isBump ? digitalProduct.pricePlans.length <= 1 : true))
    .map(digitalProduct => ({
      id: digitalProduct.id,
      caption: digitalProduct.name,
      additionalRender: getAdditionalRender?.(digitalProduct.id),
    }))
